import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { getPermittedMenuList } from "../Helpers/PermissionHandler";
import { Modal, ModalBody, ModalHeader, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import { GlobalStore } from "../StateStores";
import VehicleStatus from "../Components/Pages/VehicleStatus";
import ProfileDropdown from "../Components/Common/ProfileDropdown";
import FullScreenDropdown from "../Components/Common/FullScreenDropdown";
import LicenseStatus from "../Components/Pages/LicenseStatus";
import CreateInvoice from "../Components/Pages/Invoices/CreateInvoice";
import FireArmControlNo from "../Components/Pages/FireArm/FireArmControlNo";


const Menus = (props)=>{
    const [modal, setModal] = useState(false);
    const [activeChecker, setActiveChecker] = useState("");
    const [endCanvas, setEndCanvas] = useState(false);
    const[permittedMenuOpt,setPermittedMenuOpt] = useState([]);
    const [activeComponent, setActiveComponent] = useState("CreateInvoice");
    const {authDispatch,authState:{traversingOutState:{error,loading,data}}} = useContext(GlobalStore);

    useEffect(()=>{

        function fetchMenus(){
            let res = getPermittedMenuList();
            setPermittedMenuOpt(res)
        }

        fetchMenus();
    },[])

    const toggleEndCanvas = (type)=>{
        setEndCanvas(!endCanvas);
        setActiveChecker(type)
    }

    const togOpenModal = (component = "CreateInvoice") => {
        setActiveComponent(component);
        setModal(!modal);
    };


    return(
        <React.Fragment>
            <Offcanvas
                isOpen={endCanvas}
                direction="end">
                    <OffcanvasHeader tag="div" className=" border-bottom" toggle={()=>toggleEndCanvas('')}>
                        <span>{activeChecker}</span>
                    </OffcanvasHeader>
                    <OffcanvasBody className="p-3" style={{background:'#fbf7f4' }}>
                        {activeChecker === 'Vehicle Status' && <VehicleStatus canvas={endCanvas} setCanvas={setEndCanvas}/>}
                        {activeChecker === 'License Status' && <LicenseStatus canvas={endCanvas} setCanvas={setEndCanvas}/>}
                    </OffcanvasBody>
            </Offcanvas>

            <Modal size="md" isOpen={modal} toggle={() => togOpenModal(activeComponent)}>
                <ModalHeader toggle={() => togOpenModal(activeComponent)}> 
                    {activeComponent === "CreateInvoice" ? "Create Transaction" : "Create FireArm Control"}
                </ModalHeader>
                <ModalBody className="bg-light">
                    {activeComponent === "CreateInvoice" && <CreateInvoice />}
                    {activeComponent === "FireArmControlNo" && <FireArmControlNo modelCtrl={()=>{
                        togOpenModal("FireArmControlNo")
                    }} />}
                </ModalBody>
            </Modal>


             <div className="app-menu navbar-menu" style={{marginTop:0}}>

                <div id="scrollbar">
                    <div className="container-fluid d-flex justify-content-between">

                        <div id="two-column-menu">
                            <div className="d-flexs">
                                <div className="navbar-brand-boxs horizontal-logo">
                                    <a href="index.html" className="logo logo-dark">
                                        <span className="logo-sm">
                                            <img src="/corporationsolo.png" alt="" height="50"/>
                                        </span>
                                        <span className="logo-lg">
                                            <img src="/corporationsolo.png" alt="" height="50"/>
                                        </span>
                                    </a>

                                    <a href="index.html" className="logo logo-light">
                                        <span className="logo-sm">
                                            <img src="/corporationsolo.png" alt="" height="50"/>
                                        </span>
                                        <span className="logo-lg">
                                            <img src="/corporationsolo.png" alt="" height="50"/>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <ul className="navbar-nav" id="navbar-nav">
                            <li className="menu-title"><span data-key="t-menu">Menu</span></li>
                            <li className="nav-item">
                                <NavLink to="/" className="nav-link">
                                    <i className="ri-dashboard-2-line"></i> <span data-key="t-dashboards">Dashboards</span>
                                </NavLink>
                            </li>

                            <li className="nav-item">
                                <a 
                                className="nav-link menu-link d-flex flex-column mb-0 fs-13a" 
                                data-bs-toggle="collapse" 
                                role="button" aria-expanded="false" 
                                aria-controls="sidebarDashboards">
                                    <div className="d-flex justify-contentbetween"> 
                                        <span><i className="ri-bar-chart-2-line"></i></span>
                                        <span data-key="t-dashboards">Transaction</span>
                                    </div>
                                </a>
                                <div className="collapse menu-dropdown" id="">
                                    <ul className="nav nav-sm flex-column">
                                        <a className="nav-link fs-13a" href="#" onClick={() => togOpenModal("CreateInvoice")}>
                                            <span>Create Transaction</span>
                                        </a>
                                        <a className="nav-link fs-13a" href="#" onClick={() => togOpenModal("FireArmControlNo")}>
                                            <span>Create FireArm Control</span>
                                        </a>
                                        <NavLink to="/invoices/firearm-list" className="nav-link fs-13a">
                                            <span className="icon-ws menu-titlse">FirearmTransactions</span>
                                        </NavLink>
                                        <NavLink to="/invoices/vehicle-list" className="nav-link fs-13a">
                                            <span className="icon-ws menu-titlse">Vehicle Transactions</span>
                                        </NavLink>
                                        <NavLink to="/invoices/payment" className="nav-link fs-13a">
                                            <span className="icon-ws menu-titlse">Payments</span>
                                        </NavLink>
                                    </ul>
                                </div>
                            </li>

                            <li className="nav-item">
                                <a 
                                className="nav-link menu-link d-flex flex-column mb-0 fs-13a" 
                                data-bs-toggle="collapse" 
                                role="button" aria-expanded="false" 
                                aria-controls="sidebarDashboards">
                                    <div className="d-flex justify-contentbetween"> 
                                        <span><i className="ri-inbox-line"></i></span>
                                        <span data-key="t-dashboards">Log Book</span>
                                    </div>
                                </a>
                                <div className="collapse menu-dropdown" id="">
                                    <ul className="nav nav-sm flex-column">
                                        <a className="nav-link fs-13a" href="#" onClick={()=>toggleEndCanvas('Vehicle Status')}>
                                            <span>Vehicle Status</span>
                                        </a>
                                        <a className="nav-link fs-13a" href="#" onClick={()=>toggleEndCanvas('License Status')}>
                                            <span>License Status</span>
                                        </a>
                                        <NavLink to="/vehicle-inspection/stage" className="nav-link fs-13a">
                                            <span className="icon-ws menu-titlse">Vehicle Inspection</span>
                                        </NavLink>
                                        <NavLink to="/vehicle-inspection/checklist-manager" className="nav-link fs-13a">
                                            <span className="icon-ws menu-titlse">Checklist manager</span>
                                        </NavLink>
                                    </ul>
                                </div>
                            </li>

                            <li className="nav-item">
                                <a 
                                className="nav-link menu-link d-flex flex-column mb-0 fs-13a" 
                                data-bs-toggle="collapse" 
                                role="button" aria-expanded="false" 
                                aria-controls="sidebarDashboards">
                                    <div className="d-flex justify-contentbetween"> 
                                        <span><i className="ri-scales-line"></i></span>
                                        <span data-key="t-dashboards">Report Tool</span>
                                    </div>
                                </a>
                                <div className="collapse menu-dropdown" id="">
                                    <ul className="nav nav-sm flex-column">
                                        <NavLink to="/reports/vehicle-routes" className="nav-link fs-13a">
                                            <span className="icon-ws menu-titlse">Vehicle route</span>
                                        </NavLink>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <div className="d-flex align-items-center">
                            <FullScreenDropdown/>
                            <ProfileDropdown/>
                        </div>
                    </div>
                </div>

            {/* <div className="sidebar-backgrdound"></div> */}
        </div>

        </React.Fragment>
    );
}

export default Menus;